module.exports = __webpack_public_path__ + "static/16159505-c85d-44ba-ba2b-64f94e68ddb5-4e89937dc5aae09e71312ef623b1178c.ttf";